import { useState } from 'react'

/**
 * Tracks the ids of documents that the user has uploaded or deleted during form submission,
 * record update/create, or table cell update/create
 */
export const useTrackDocumentIds = () => {
  const [documentIds, setDocumentIds] = useState<string[]>([])

  const addDocumentId = (documentId: string) => {
    const updatedDocumentIds = [...documentIds]
    // If document id doesn't already exist in documentIds, add it
    const index = updatedDocumentIds.findIndex((id) => id === documentId)
    if (index === -1) {
      updatedDocumentIds.push(documentId)
      setDocumentIds(updatedDocumentIds)
    }
  }

  const removeDocumentId = (documentId: string) => {
    const updatedDocumentIds = [...documentIds]
    // If document id already exist in documentIds, remove it
    const index = updatedDocumentIds.findIndex((id) => id === documentId)
    if (index !== -1) {
      updatedDocumentIds.splice(index, 1)
      setDocumentIds(updatedDocumentIds)
    }
  }

  return {
    addDocumentId,
    removeDocumentId,
    documentIds,
  }
}
